/*
*	Google Maps librairy - MG2 Media
*	@author Mathilde Paccoud & François Vandal
*	@version: 0.3
*	Last update: 7 mars 2016
*/

(function($, global, undefined) {
	
	'use strict';
	var win = $(window);
	var winWidth;
	
	var counter = 0;
	var distance = 15;
	var maxResults = 25;
	var eleMaps;
	var loadings;
	var mapsList = {};
	var currInfoOpen = '';
	
	/* =========== */
	var taxo = [];
	var taxoItems = [];
	var subCatBtn;
	var noResultMap;
	var noResultList;
	var indexInputLocation;
	var locationGeo;
	var rechercheHeaderInputLocation;
	var recherchePopupInput;
	var allMarkers = [];
	var loadingPannels;
	/* =========== */
	
	var markerDefault = {
		imageName: 'map-marker.png'
	};
	var markerManyDefault = {
		imageName: 'map-marker-many.png'
	};
	
	var defaults = {
		latitude: 45.50867,
		longitude: -73.553992,
		zoom: 14,
		scrollwheel: false,
		getLocalMarker: true,
		getAjaxMarkerList: false,
		cluster: false,
		ajaxMarkerListDistance: 15,
		ajaxMarkerListMaxResults: 25,
		ajaxReloadOnClick: true
	};
	
	/*var getLatLng = function (address,id) {
		var geo = new google.maps.Geocoder();
		geo.geocode({'address':address},function(results, status){
			if (status == google.maps.GeocoderStatus.OK) {
				document.getElementById("lat").value = results[0].geometry.location.lat();
				document.getElementById("lng").value = results[0].geometry.location.lng();
				if(id && id != ''){
					document.getElementById(id).submit();
				}
				if(id == ''){
					addMarkerInner()
				}
			} else {
				return false;
			}
		});
	}
	
	var getLatLngOrg = function (lang, name, address, city, postalCode, province) {
		var lat, lng;
		var geo = new google.maps.Geocoder();
		var str = address+' '+city+' '+postalCode+' '+province;
		setTimeout(function(addr, recId) {
			geo.geocode({'address':str},function(results, status){
				if (status == google.maps.GeocoderStatus.OK) {
					lat = results[0].geometry.location.lat();
					lng = results[0].geometry.location.lng();            
					addMarkerInner(lang, lat, lng, name, address, city, postalCode, province);
				} 
				else {
					console.log("wrong address "+status);
				}
			});
		},1200);
	};*/
	
	var rebuildList = function (obj) {
		var params = getUrlVars();
		var isTaxo = Object.keys(taxoItems).length > 0 ? true : false;
		var toCheck = isTaxo ? taxoItems : obj;
		var totalItemsToCheck = Object.keys(toCheck).length;
		var isChecked = [];
		var ctn = $('.recherche-content');
		var paramLat = params.lat !== undefined ? params.lat : ctn.data('lat');
		var paramLng = params.lng !== undefined ? params.lng : ctn.data('lng');
		var lat = paramLat === undefined ? '' : paramLat;
		var lng = paramLng === undefined ? '' : paramLng;
		
		
		for (var q = 0; q < totalItemsToCheck; q++) {
			var duplicate = false;
			
			
			for (var f = 0; f < isChecked.length; f++) {
				if (decodeText(isChecked[f].name) === decodeText(toCheck[q].name)) {
					duplicate = true;
				}
			}
			
			if (!duplicate) {
				isChecked.push(toCheck[q]);
			}
		}
		
		var totalItems = Object.keys(isChecked).length;
		
		var listResultat = $('.recherche-content-liste-resultat');
		var listResultatFirst = $('.recherche-content-liste-resultat-first-item', listResultat);
		var listResultatLast = $('.recherche-content-liste-resultat-last-item', listResultat);
		var listResultatTotal = $('.recherche-content-liste-resultat-total-item', listResultat);
		var mapResultat = $('.recherche-content-map-resultat');
		var mapResultatTotal = $('.recherche-content-map-resultat-total-item', mapResultat);
		var pager = $('.recherche-content-pager');
		
		/* Pager */
		listResultatFirst.html(1);
		listResultatLast.html(totalItems);
		listResultatTotal.html(totalItems);
		mapResultatTotal.html(totalItems);
		pager.html('');
		
		/* List */
		var list = $('.recherche-content-list-ctn');
		var listItemVoid = $('.recherche-content-list-item.void');
		var itemArray = [];
		
		if (isTaxo) {
			taxoItems.sort(function compare(a,b) {
				if (a.name < b.name)
					return -1;
				else if (a.name > b.name)
					return 1;
				else 
					return 0;
			});
		}
		
		for (var i = 0; i < totalItems; i++) {
			var localIndex = i;
			var allFields = isChecked[localIndex].description.AllFields;
			var newListItemVoid = listItemVoid.clone();
			var adresse = isChecked[localIndex].address;
			var href = $('.recherche-content-list-item-title', newListItemVoid).attr('href').split('?')[0];
			var newParams = $('.recherche-content-list-item-title', newListItemVoid).attr('href').split('?')[1];
			var title = decodeText(isChecked[localIndex].name);
			var itemDistance = $('.recherche-content-list-item-distance', newListItemVoid);
			var itemDistanceVal = $('.recherche-content-list-item-distance-value', itemDistance);
			
            // Trim empty path that ends with "/"
            if (href && href.endsWith('/')) {
                href = href.substr(0, href.length - 1);
            }
            
			if (isChecked[localIndex].city !== '') {
				if (isChecked[localIndex].address !== '') {
					adresse += ', ';
				}
				adresse += isChecked[localIndex].city;
			}
			
			if (isChecked[localIndex].description.AllFields.PhysicalCounty !== '') {
				if (isChecked[localIndex].address !== ''|| 
					isChecked[localIndex].city !== '') {
					adresse += ', ';
				}
				adresse += isChecked[localIndex].description.AllFields.PhysicalCounty;
			}
			
			if (isChecked[localIndex].province !== '') {
				if (isChecked[localIndex].address !== '' || 
					isChecked[localIndex].city !== ''  ||
					isChecked[localIndex].description.AllFields.PhysicalCounty !== '') {
					adresse += ', ';
				}
				adresse += isChecked[localIndex].province;
			}
			
			if (isChecked[localIndex].postalCode !== '') {
				if (isChecked[localIndex].address !== '' ||
					isChecked[localIndex].city !== '' || 
					isChecked[localIndex].description.AllFields.PhysicalCounty ||
					isChecked[localIndex].province !== '') {
					adresse += ', ';
				}
				adresse += isChecked[localIndex].postalCode;
			}
			
			if (itemDistance.length !== 0) {
				if (isChecked[localIndex].lat === '' || isChecked[localIndex].lat === '0.0' ||
					isChecked[localIndex].lng === '' || isChecked[localIndex].lng === '0.0' ||
					isChecked[localIndex].description.AllFields.PhysicalAddressIsPrivate === 'Yes') {
					itemDistance.html(decodeText(itemDistance.attr('data-confidential-value')));
				} else {
					itemDistanceVal.html(isChecked[localIndex].distanceFromCenter.toFixed(2));
				}
			}
			
            // Check if the document is not in the iframe "rechercheFrame"
            if (!$('.recherche-content').hasClass('is-out')) {
                // On recherche page the path is "organisme" + friendlyUrl
                if (href.lastIndexOf('/') !== 0) {
                    href += '/';
                }
                href += decodeText(isChecked[localIndex].friendlyUrl);
                if (newParams && newParams !== '') {
                    href += '?' + newParams;
                }
            } else {
                // Inside the iframe the path stays as "rechercheframe" so we don't change the path
                href += '?';
                if (newParams && newParams !== '') {
                    href += newParams + '&';
                }
                href += 'id=' + isChecked[localIndex].id;
            }
            
			newListItemVoid.removeClass('void');
			$('.recherche-content-list-item-title', newListItemVoid)
                .attr('href', href)
                .html((title !== undefined) ? title.toString() : "");
			$('.organisme-address', newListItemVoid).html(decodeText((adresse !== undefined) ? adresse.toString() : ""));
            
            // Description de service
            if (allFields.MetaDescription) {
                var trimmedDescription = decodeText(allFields.MetaDescription.substr(allFields.MetaDescription.indexOf(': ') + 2).trim());
                if (trimmedDescription.length > 200) {
                    $('.organization-item-text-description', newListItemVoid).text(trimmedDescription.substr(0, 200) + '... ');
                    $('.organization-item-text-description-link', newListItemVoid)
                        .css('display', '')
                        .attr('href', href + '#organisme-content-info');
                } else {
                    $('.organization-item-text-description', newListItemVoid).text(trimmedDescription);
                    $('.organization-item-text-description-link', newListItemVoid)
                        .css('display', 'none')
                        .attr('href', href + '#organisme-content-info');
                }
                $('.organization-item-text-description', newListItemVoid)
                    .closest('.recherche-content-list-item-description').css('display', '');
            }
            
            // Precision sur l'offre
            if (allFields.TemporaryMessage) {
                $('.organization-item-text-offer', newListItemVoid)
                    .text(decodeText(allFields.TemporaryMessage))
                    .closest('.recherche-content-list-item-description').css('display', '');
            }
            
			if (allFields.Phone1Number !== undefined) {
				if (allFields.Phone1Number.toString() !== '' && allFields.Phone1IsPrivate.toString() !== 'True') {
					$('.organization-item-link.phone .organization-item-link-title', newListItemVoid).html(decodeText(allFields.Phone1Number.toString()));
				} else {
					$('.organization-item-link.phone', newListItemVoid).remove();
				}
			} else {
				$('.organization-item-link.phone', newListItemVoid).remove();
			}
			
			if (allFields.WebsiteAddress.toString() !== '') {
				var link = '';
				
				if (decodeText(allFields.WebsiteAddress.toString()).substring(0, 4) !== 'http') {
					link += 'http://';
				}
				
				link += decodeText(allFields.WebsiteAddress.toString());
				
				$('.organization-item-link.website', newListItemVoid).attr('href', link);
				$('.organization-item-link.website', newListItemVoid).attr('target', '_blank');
				$('.organization-item-link.website .organization-item-link-title', newListItemVoid).html(decodeText(allFields.WebsiteAddress.toString()));
			} else {
				$('.organization-item-link.website', newListItemVoid).remove();
			}
			
			if (allFields.EmailAddressMain !== undefined && allFields.EmailAddressMain.toString() !== '') {
				$('.organization-item-link.email', newListItemVoid).attr('href', 'mailto:' + decodeText(allFields.EmailAddressMain.toString()));
				
				$('.organization-item-link.email .organization-item-link-title', newListItemVoid).html(decodeText(allFields.EmailAddressMain.toString()));
			} else {
				$('.organization-item-link.email', newListItemVoid).remove();
			}
			
			if (allFields.CoverageArea !== undefined && allFields.CoverageArea.toString() !== '') {
				$('.organization-item-link.territory .organization-item-link-title', newListItemVoid).html(decodeText(allFields.CoverageArea.toString()));
			} else {
				$('.organization-item-link.territory', newListItemVoid).remove();
			}
			
			if (allFields.Eligibility !== undefined && allFields.Eligibility.toString() !== '') {
				$('.organization-item-link.clientele .organization-item-link-title', newListItemVoid).html(decodeText(allFields.Eligibility.toString()));
			} else {
				$('.organization-item-link.clientele', newListItemVoid).remove();
			}
			
			itemArray.push({title: title, ele: newListItemVoid, PhysicalAddressIsPrivate: isChecked[localIndex].description.AllFields.PhysicalAddressIsPrivate, distanceFromCenter: isChecked[localIndex].distanceFromCenter});
		}
		
		// IMPORTANT If the sorting methods here are modified, the ones in page/organisme.js must be updated too
        if (params.sort === 'proximity' && lng !== undefined && lat !== undefined) {
			for (var b = 0; b < itemArray.length; b++) {
				if (itemArray[b].PhysicalAddressIsPrivate !== 'Yes') {
					itemArray[b].ele.appendTo(list);
				}
			}
			for (var c = 0; c < itemArray.length; c++) {
				if (itemArray[c].PhysicalAddressIsPrivate === 'Yes') {
					itemArray[c].ele.appendTo(list);
				}
			}
		} else {
            itemArray.sort(function compare(a, b) {
                return removeDiacritics(a.title.replace(/[\u0300-\u036f]/g, "")).localeCompare(
                    removeDiacritics(b.title.replace(/[\u0300-\u036f]/g, "")));
            });
            if (params.desc === 'true') {
                for (var x = itemArray.length - 1 ; x >= 0; x--) {
                    itemArray[x].ele.appendTo(list);
                }
            } else {                
                for (var x = 0; x < itemArray.length; x++) {
                    itemArray[x].ele.appendTo(list);
                }
            }
        }
	};
	
	var getUrlVars = function () {
		var vars = [], hash;
		if (window.location.href.indexOf('?') !== -1) {
			var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
			for(var i = 0; i < hashes.length; i++) {
				hash = hashes[i].split('=');
				//vars.push(hash[0]);
				vars[hash[0]] = hash[1];
			}
			return vars;
		} else {
			return [];
		}
	};
	
	var centerMapByCoor = function (mapClass, myLatlng) {
		var currMap = mapsList[mapClass].theMap;
		
		// currMap.setCenter(myLatlng);
	};
	
	var addSingleMarkersAjax = function (unObj, mapClass, myLatlng, element, loading) {
		var currMap = mapsList[mapClass].theMap;
		
		$('.gmap-loading').fadeOut(2000);
		
		var markerOptions = {
			imageName: unObj.data('makerName'),
			id: unObj.data('getLocalMarkerAjax')
		};
		var markerSettings = $.extend({}, markerDefault, markerOptions);
		
		var windowString = '<div class="contentString">';
		windowString += infowindowContent(null, element.attr('data-name'), 
            element.attr('data-address'), '', 
			element.attr('data-city'), element.attr('data-postal'), 
			element.attr('data-province'), element.attr('data-phone'), 
			element.attr('data-phone-private'), element.attr('data-website'), 
            markerSettings);
		windowString += '</div>';
		
		var infowindow = new google.maps.InfoWindow({
			content: windowString,
            disableAutoPan: true
		});
		
		var marker = new google.maps.Marker({
			position: myLatlng,
			title: unObj.data('name'),
			icon: '/static/assets/img/' + markerSettings.imageName
		});
		
//		var query = '/action/getOrganizations?field1='+markerOptions.id;
		marker.setMap(currMap);
		
		mapsList[mapClass] = $.extend(mapsList[mapClass], {markers: marker});
		
		google.maps.event.addListener(marker, 'click', function() {
			if (currInfoOpen !== infowindow) {
				if (currInfoOpen !== '') {
					currInfoOpen.close();
				}
				// currMap.setCenter(myLatlng);
				infowindow.open(currMap, marker);
				currInfoOpen = infowindow;
			}
		});
		
//		var obj = ajax(query,function (response) {
//			getJson(response, mapClass, element, loading);
//		},true);
	};
	
	var getMarkers = function (mapClass, distance, maxResults, element){
		var params = getUrlVars();
		var ctn = $('.recherche-content');
		var paramLat = params.lat !== undefined ? params.lat : ctn.data('lat');
		var paramLng = params.lng !== undefined ? params.lng : ctn.data('lng');
		var lat = paramLat === undefined ? '' : paramLat;
		var lng = paramLng === undefined ? '' : paramLng;
		
		var currMap = mapsList[mapClass].theMap;
		var mapCenter = currMap.getCenter();
		var loadingCtn = element.siblings('.gmap-loading');
		var loading = $('.gmap-loading-item', loadingCtn);
		var q = params.q === undefined ? '' : decodeURIComponent(params.q);
		var location = params.place === undefined ? '' : decodeURIComponent(params.place);
		var field4 = params.field4 === undefined ? '' : decodeURIComponent(params.field4);
		var field5 = params.field5 === undefined ? '' : decodeURIComponent(params.field5);
		var field9 = params.field9 === undefined ? '' : decodeURIComponent(params.field9);
		var field11 = params.field11 === undefined ? '' : decodeURIComponent(params.field11);
		var field12 = params.field12 === undefined ? '' : decodeURIComponent(params.field12);
		var field13 = params.field13 === undefined ? '' : decodeURIComponent(params.field13);
		var field14 = params.field14 === undefined ? '' : decodeURIComponent(params.field14);
		var field15 = params.field15 === undefined ? '' : decodeURIComponent(params.field15);
		var ignoreServe = params.ignoreServe === undefined ? '' : decodeURIComponent(params.ignoreServe);
        var splitField4 = params.splitField4 === undefined ? '' : decodeURIComponent(params.splitField4);
        var splitField5 = params.splitField5 === undefined ? '' : decodeURIComponent(params.splitField5);
        
		getTaxoArray();
        
		var query = '/action/getOrganizations?ajax=true&distance='+distance+'&maxResults='+maxResults;
        if (params.catId !== undefined) {
            query += '&cat-id=' + params.catId;
        } else if (params['cat-id'] !== undefined) {
            query += '&cat-id=' + params['cat-id'];
        }
        if (params.subCat !== undefined) {
            query += '&sub-cat=' + params.subCat;
        } else if (params['sub-cat'] !== undefined) {
            query += '&sub-cat=' + params['sub-cat'];
        }
		if (q !== '') {
			query += '&q='+q;
		}
		saveSessionVariable('place', location);
		saveSessionVariable('location', location);

		if (location !== '') {
			query += '&place='+location;
		}
		if (field4 !== '') {
			query += '&field4='+field4;
		}
		if (field5 !== '') {
			query += '&field5='+field5;
		}
		if (field9 !== '') {
			query += '&field9='+field9;
		}
		if (field11 !== '') {
			query += '&field11='+field11;
		}
		if (field12 !== '') {
			query += '&field12='+field12;
		}
		if (field13 !== '') {
			query += '&field13='+field13;
		}
		if (field14 !== '') {
			query += '&field14='+field14;
		}
		if (field15 !== '') {
			query += '&field15='+field15;
		}
		if (lat !== '') {
			query += '&lat='+lat;
		}
		if (lng !== '') {
			query += '&lng='+lng;
		}
		if (ignoreServe !== '') {
			query += '&ignoreServe='+ignoreServe;
		}
		if (splitField4 !== '') {
			query += '&splitField4='+splitField4;
		}
		if (splitField5 !== '') {
			query += '&splitField5='+splitField5;
		}
		//loading.show();
		/*var obj = ajax(query,function (response) {
            try {
                getJson(response, mapClass, element, loading);
            } catch (e) {
            }
		},true);*/
		query = encodeURI(query);
		$.ajax({
			url: query,
			cache: false,
			method: 'POST',
			processData: false,
			success: function (response) {
				getJson(response, mapClass, element, loading);
			}
		});
	};
	
    function jsonEscape(str) {
        // Ref. http://json.org/
    //    return str.replace(/\0/g, "")
    //                .replace(/\\/g, "\\\\")
    //                .replace(/\//g, "\\/")
    //                .replace(/\n/g, "\\n")
    //                .replace(/\f/g, "\\f")
    //                .replace(/\r/g, "\\r")
    //                .replace(/\t/g, "\\t")
    //                .replace(/\v/g, "\\v");
        return str.replace(/\//g, "\\/");
    }
    
	var getJson = function (response, mapClass, element, loading){
		var currMap = mapsList[mapClass].theMap;
		var settings = mapsList[mapClass].settings;
//        var resp = jsonEscape(response.trim());
		var obj = [{}];
		// Useful when investigating JSON bugs in IE11 because the console doesn't show the entire output
		/*if(document.getElementById('topMenuBar')) {
			var textarea = document.createElement('textarea');
			textarea.innerHTML = resp;
			$('body').append(textarea);
		}*/
        try {
            obj = typeof response === 'string' ? JSON.parse(response) : response;
        } catch (e) {
            console.log(e);
        }
		var objFiltereredByMarkers = [];
		var lang = $('html').attr('lang');
		var markersArray = [];
		var markersMap = {}; // map par lat|lng : [marqueurs]
		var url = location.href;
		var params = getUrlVars();
		var isTaxo = params['cat-id'] !== undefined ? true : false;
		var count = 0;
        
		var mapResultatConfidentielleCtn = $('.recherche-content-map-resultat-item-confidentielle-ctn');
		var mapResultatConfidentielle = $('.recherche-content-map-resultat-item-confidentielle', mapResultatConfidentielleCtn);
		var totalConfidentielle = 0;
		
        var langArray = [];
        
        if (lang === 'fr' && params.splitField4) {
            langArray = params.splitField4.split(',');
        } else if (params.splitField5) {
            langArray = params.splitField5.split(',');
        }
        langArray.forEach(function(value, index) {
            langArray[index] = decodeURIComponent(value).trim();
        });
        
		taxoItems = [];
		for (var i = 0; i < obj.length; i++) {
            // Add the matched organization in the list
            taxoItems.push(obj[i]);
            count++;

            var exists = false;
            var id = obj[i].id;
            var lat = obj[i].lat;
            var lng = obj[i].lng;
            var isPrivate = obj[i].description.AllFields.PhysicalAddressIsPrivate;
            var name = decodeText(obj[i].name);
            var fUrl = obj[i].friendlyUrl;
            var latLngKey = lat + '|' + lng;
            if (markersMap[latLngKey] && markersMap[latLngKey].length > 0) {
                for(var x = 0; x < markersMap[latLngKey].length; x++) {
                    if ( markersMap[latLngKey][x][1] === name) {
                        exists = true;
                    }
                }
            }
            var address = decodeText(obj[i].address);
            var city = decodeText(obj[i].city);
            var postalCode = decodeText(obj[i].postalCode);
            var province = decodeText(obj[i].province);
            var markerName = decodeText(obj[i].field1);
            if (lat === 0 && lng === 0) {
                totalConfidentielle++;
            }
            if(!exists && lat !== 0 && lat !== '' && lng !== 0 && lng !== '' && isPrivate !== 'Yes'){
                markerName = encodeText(markerName);
                addMarkerInner(lang,id, lat, lng, name, address, fUrl, city, postalCode, province, markerName, mapClass, element, markersMap, obj[i].description);
                objFiltereredByMarkers.push(obj[i]);
            }
		}
		for (var i in Object.keys(markersMap)) {
			var key = Object.keys(markersMap)[i];
			var arr = markersMap[key];
			markersArray = markersArray.concat(arr);
		}
		for (var v = 0; v < allMarkers.length; v++) {
			allMarkers[v][0].setMap(null);
		}
		for (var f = 0; f < markersArray.length; f++) {
			markersArray[f][0].setMap(currMap);
		}
		
		//Calculate # of confidential
		mapResultatConfidentielle.html(totalConfidentielle);
		
		if (totalConfidentielle !== 0) {
			mapResultatConfidentielleCtn.addClass('show');
		} else {
			mapResultatConfidentielleCtn.removeClass('show');
		}
		
		
		//Rebuild list with cat and sub-cat
		if (isTaxo) {
			rebuildList(objFiltereredByMarkers);
		}
		
		mapsList[mapClass] = $.extend(mapsList[mapClass], {markers: markersArray});
		
		loading.fadeOut(3000);
		loadingPannels.addClass('hide');
		
		if (objFiltereredByMarkers.length !== 0 && objFiltereredByMarkers.length !== undefined) {
			noResultMap.removeClass('show');
			noResultList.removeClass('show');
			if (markersArray.length !== 0) {
				if (!isTaxo || isTaxo && taxoItems.length > 0) {
					if (!settings.cluster) {
						setMapBound(mapClass);
					} else {
						clusterIt(mapClass, markersArray, {maxZoom: 14});
					}
				} else {
					var myLatlng = new google.maps.LatLng(settings.latitude,settings.longitude);
					
					centerMapByCoor(mapClass, myLatlng);
					currMap.setZoom(settings.zoom);
				}
			} else {
				$('.section-search').removeClass('open-map').addClass('open-list');
				
				var newUrl = updateQueryStringParameter(url, 'list', 'true');
				window.history.pushState({'pageId': 'recherche'}, 'pageId', newUrl);
			}
		} else if (parseInt($('.recherche-content-liste-resultat-total-item').html()) <= 0) {
			noResultMap.addClass('show');
			noResultList.addClass('show');
		} else {
			$('.recherche-content-map-resultat-item-confidentielle').html($('.recherche-content-liste-resultat-total-item').html());
		}
	};
	
	var addMarkerInner = function (lang,id, lat, lng, name, address, fUrl, city, postalCode, province, markerName, mapClass, element, markersMap, description) {
		var currMap = mapsList[mapClass].theMap;
		var many = false;
		var markerOptions = {
			imageName: element.data('makerName'),
			btnValue: element.data('popupBtnValue'),
			btnUrlBeforeId: element.data('popupUrlBeforeId'),
            isFrame: element.data('isFrame')
		};
		
		var markerSettings = $.extend({}, markerDefault, markerOptions);
		
		var myLatlng = new google.maps.LatLng(lat,lng);
		var windowString;
		var duplicateString = '<div class="info_splicer">' +
                infowindowContent(id, name, address, fUrl, city, postalCode, province, description.AllFields.Phone1Number,
                description.AllFields.Phone1IsPrivate, description.AllFields.WebsiteAddress, markerSettings) +'</div>';
		var contentString;
		var latLngKey = lat + '|' + lng;
	
		if (markersMap[latLngKey] && markersMap[latLngKey].length > 0) {
			for(var j = 0; j < markersMap[latLngKey].length; j++) {
                if (name !== markersMap[latLngKey][j][1]) {
                    duplicateString += (markersMap[latLngKey][j][2] !== undefined) ? markersMap[latLngKey][j][2] : "";
                    many = true;
                    markersMap[latLngKey].splice(j, 1);
                }
			}
		}
		else {         
            windowString = '<div class="contentString">';
            windowString += infowindowContent(id, name, address, fUrl, city, postalCode, province, description.AllFields.Phone1Number,
            description.AllFields.Phone1IsPrivate, description.AllFields.WebsiteAddress, markerSettings);
            windowString += '</div>';
        }
	
		
		var infowindow = new google.maps.InfoWindow({
			content: ((many) ? '<div class="contentString">' + duplicateString + '</div>' : windowString),
            disableAutoPan: true
		});
		
		var marker = new google.maps.Marker({
			position: myLatlng,
			title: name,
			icon: '/static/assets/img/' + markerSettings.imageName
		});
		if(many){
            marker.icon = '/static/assets/img/' + markerManyDefault.imageName;
        }
		google.maps.event.addListener(marker, 'click', function() {
			if (currInfoOpen !== infowindow) {
				if (currInfoOpen !== '') {
					currInfoOpen.close();
				}
				// currMap.setCenter(new google.maps.LatLng(lat,lng));
				infowindow.open(currMap, marker);
				currInfoOpen = infowindow;
			}
		});
		
		allMarkers.push([marker,name, duplicateString, many]);
		//markersArray.push([marker,name, duplicateString, many]);
		if (!markersMap[latLngKey]) {
			markersMap[latLngKey] = [];
		}
		markersMap[latLngKey].push([marker,name, duplicateString, many]);
	};

	var infowindowContent = function (id, name, address, fUrl, city, postalCode, province, phone, phone1IsPrivate, website, markerSettings) {
		var contentString = '<a class="info_title" ';

		if (markerSettings.btnValue !== undefined && markerSettings.btnUrlBeforeId !== undefined) {
			contentString += 'href="' + markerSettings.btnUrlBeforeId;
            if (markerSettings.isFrame !== 'true' && !markerSettings.isFrame) {
                if (!markerSettings.btnUrlBeforeId.endsWith('/') && !fUrl.startsWith('/')) {
                    contentString += '/';
                }
                contentString += fUrl;
                if (location.search !== '') {
                    contentString += location.search;
                }
                contentString += '" target="_parent">';
            } else {
                if (location.search !== '') {
                    contentString += location.search + '&id=' + id;
                } else {
                    contentString += '?id=' + id;
                }
                contentString += '" target="_self">';
            }
		} else {
			contentString +='href="https://maps.google.com/maps?daddr='+address+'+'+city+'+'+postalCode+'+'+province+'" target="_blank">';
		}

		contentString += name+'</a>';
		contentString += '<p class="info_address address">'+address+'</p>';
		contentString += '<p class="info_address city">'+city;
		if (postalCode !== '') {
			if (city !== '') {
				contentString += ', ';
			}
			contentString += postalCode;
		}

		if (postalCode !== '') {
			if (city !== '' || postalCode !== '') {
				contentString += ', ';
			}
			contentString += province;
		}
		contentString += '</p>';

		if (phone !== '' && phone1IsPrivate !== true) {
			contentString += '<p><a href="tel:';
			contentString += phone;
			contentString += '">';
			contentString += phone;
			contentString += '</a></p>';
		}

		if (website !== '') {
			contentString += '<p><a href="';
			
			if (website.substring(0, 4) !== 'http') {
				contentString += 'http://';
			}
			
			contentString += website;
			contentString += '" target="_blank">';
			contentString += website;
			contentString += '</a></p>';
		}

		contentString += '<a class="info_link" ';

		if (markerSettings.btnValue !== undefined && markerSettings.btnUrlBeforeId !== undefined) {
            contentString += 'href="' + markerSettings.btnUrlBeforeId;
            if (markerSettings.isFrame !== 'true' && !markerSettings.isFrame) {
                if (!markerSettings.btnUrlBeforeId.endsWith('/') && !fUrl.startsWith('/')) {
                    contentString += '/';
                }
                contentString += fUrl;
                if (location.search !== '') {
                    contentString += location.search;
                }
                contentString += '" target="_parent">';
            } else {
                if (location.search !== '') {
                    contentString += location.search + '&id=' + id;
                } else {
                    contentString += '?id=' + id;
                }
                contentString += '" target="_self">';
            }
			contentString += markerSettings.btnValue;
		} else {
			contentString +='href="https://maps.google.com/maps?daddr='+address+'+'+city+'+'+postalCode+'+'+province+'" target="_blank">';
			if($('html').attr('lang') == 'fr'){
				contentString +='Obtenir l\'itin\xE9raire';
			}
			else{
				contentString +='Get directions';
			}
		}

		contentString += "</a><br/>";

		var duplicateString = contentString;
		      

		if (duplicateString.substring(0, 9) === 'undefined') {
			duplicateString = duplicateString.substring(9);
		}

		return duplicateString;
	};

	var addSingleMarkers = function (obj, mapClass, myLatlng, loading) {
		var currMap = mapsList[mapClass].theMap;
		
		var markerOptions = {
			imageName: obj.data('makerName')
		};
		
		var markerSettings = $.extend({}, markerDefault, markerOptions);
		
		var marker = new google.maps.Marker({
			position: myLatlng,
			title: obj.data('name'),
			icon: '/static/assets/img/' + markerSettings.imageName
		});
		
		marker.setMap(currMap);
		
		mapsList[mapClass] = $.extend(mapsList[mapClass], {markers: marker});
		
		loading.fadeOut(3000);
	};
	
	var updateQueryStringParameter = function (uri, key, value) {
		var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
		var separator = uri.indexOf('?') !== -1 ? "&" : "?";
		if (uri.match(re)) {
			return uri.replace(re, '$1' + key + "=" + value + '$2');
		}
		else {
			return uri + separator + key + "=" + value;
		}
	};
	
	var clusterIt = function (mapClass, markersArray, options){
		var ele = $('#'+mapClass);
		var currMap = mapsList[mapClass].theMap;
		var currMarkers = [];
		
		var eleOptions = {
			latitude: ele.data('latitude'),
			longitude: ele.data('longitude'),
			zoom: ele.data('zoom')
		};
		
		var settings = $.extend({}, defaults, eleOptions);
		
		var myLatlng = new google.maps.LatLng(settings.latitude,settings.longitude);
		currMap.setCenter(myLatlng);
		
		for (var i = 0; i < markersArray.length - 1; i++) {
			currMarkers.push(markersArray[i][0]);
		}
		
		if (mapsList[mapClass].cluster !== undefined) {
			mapsList[mapClass].cluster.clearMarkers();
			mapsList[mapClass].cluster.resetViewport(true);
			//setMapBound(mapClass);
			// currMap.setCenter(myLatlng);
			currMap.setZoom(settings.zoom);
		} else {
			mapsList[mapClass].cluster = new MarkerClusterer(currMap, currMarkers, options);
		}
	};
	
	var createMaps = function () {
		var params = getUrlVars();
		var location = params.place === undefined ? '' : params.place;
		location = decodeURIComponent(location);
		
		var request = {
			componentRestrictions: {country: "ca"}
		};

		
		if (indexInputLocation[0] !== undefined) {
			for (var item = 0; item < indexInputLocation.length; item++) {
				new google.maps.places.Autocomplete(indexInputLocation[item], request);
			}
		}
		
		if (rechercheHeaderInputLocation[0] !== undefined) {
			var autocomplete = new google.maps.places.Autocomplete(rechercheHeaderInputLocation[0], request);
		}
		
		if (recherchePopupInput[0] !== undefined) {
			var autocompleteTwo = new google.maps.places.Autocomplete(recherchePopupInput[0], request);
		}
		
		eleMaps.each(function () {
			var t = $(this);
			var addedClass;
			
			if (t.attr('id') !== 0) {
				addedClass = t.attr('id');
			} else {
				addedClass = 'map-created-' + t.index();
				t.attr('id', addedClass);
			}
			
			var options = {
				latitude: t.data('latitude'),
				longitude: t.data('longitude'),
				zoom: t.data('zoom'),
				scrollwheel: t.data('scrollwheel'),
				getLocalMarker: t.data('getLocalMarker'),
				getLocalMarkerAjax: t.data('getLocalMarkerAjax'),
				getAjaxMarkerList: t.data('getAjaxMarkerList'),
				ajaxMarkerListDistance: t.data('ajaxMarkerListDistance'),
				ajaxMarkerListMaxResults: t.data('ajaxMarkerListMaxResults'),
				ajaxReloadOnIdle: t.data('ajaxReloadOnIdle'),
				cluster: t.data('cluster')
			};
			var settings = $.extend({}, defaults, options);
			
			var myLatlng = new google.maps.LatLng(settings.latitude,settings.longitude);
			var mapOptions = {
				zoom: settings.zoom,
				center: myLatlng,
				scrollwheel: settings.scrollwheel,
				mapTypeId: google.maps.MapTypeId.ROADMAP
			};
			
			var map = new google.maps.Map(t.get(0), mapOptions);
			var geocoder = new google.maps.Geocoder();
			
			mapsList[addedClass] = {
				theMap: map,
				settings: settings
			};
			
			var styledMap = new google.maps.StyledMapType(styles,{name: "Styled Map"});
			
			map.mapTypes.set('map_style', styledMap);
			map.setMapTypeId('map_style');
			
			if (loadings.length !== 0) {
				loadings.ClassyLoader({
					width: 50,
					height: 50,
					fontSize: 10,
					diameter: 20,
					fontFamily: 'Lato'
				});
			}
			
			if (location !== '' && settings.getAjaxMarkerList) {
				codeAddress(map, geocoder, location);
			}
			
			google.maps.event.addListenerOnce(map, 'tilesloaded', function() {
				if (settings.getLocalMarker) {
					if (settings.getLocalMarkerAjax) {
						addSingleMarkersAjax(t, addedClass, myLatlng, t, loadings);
					} else {
						addSingleMarkers(t, addedClass, myLatlng, loadings);
					}
				}
				if (settings.getAjaxMarkerList && !settings.getLocalMarker) {
					if (settings.ajaxReloadOnIdle) {
						google.maps.event.addListener(map, 'idle', function() {
							getMarkers(addedClass,settings.ajaxMarkerListDistance,settings.ajaxMarkerListMaxResults, t);
						});
					} else {
						getMarkers(addedClass,settings.ajaxMarkerListDistance,settings.ajaxMarkerListMaxResults, t);
					}
				}
			});
		});
	};
	
	var codeAddress =  function (map, geocoder, location) {
		geocoder.geocode({'address': location, componentRestrictions: {country: 'CA'}}, function(results, status) {
			if (status == google.maps.GeocoderStatus.OK) {
				// map.setCenter(results[0].geometry.location);
				map.setZoom(defaults.zoom);
			} else {
				alert("Geocode was not successful for the following reason: " + status);
			}
		});
	};
	
	var getTaxoArray = function () {
		taxo = [];
		var items = $('.recherche-filtre-sub-list-item.active');
		
		items.each(function () {
			var t = $(this);
			var itemTaxo = t.attr("data-taxo");
			var itemTaxoArray = itemTaxo.split(',');
			
			for(var k=0; k<itemTaxoArray.length;k++){
				if (taxo.indexOf(itemTaxoArray[k]) == -1) {
					taxo.push(itemTaxoArray[k]);
				}
			}
		});
	};
	
	var setMapBound = function (addedClass) {
		var currMap = mapsList[addedClass].theMap;
		var markers = mapsList[addedClass].markers;
		var bounds = new google.maps.LatLngBounds();
		
		for (var i = 0; i < markers.length; i++) {
			bounds.extend(markers[i][0].getPosition());
		}
		
		currMap.fitBounds(bounds);
		
		if (currMap.getZoom() > mapsList[addedClass].settings.zoom) {
			currMap.setZoom(mapsList[addedClass].settings.zoom);
		}
	};
	
	var setMapOnAll = function (map) {
		var currMap = mapsList[map];
		var currMarkers = currMap.markers;
		
		for (var i = 0; i < currMarkers.length; i++) {
			currMarkers[i][0].setMap(null);
		}
	};
	
	var clearMap = function (map) { 
		setMapOnAll(map);
		mapsList[map].markers = [];
		setMapBound(map);
	};
	
	var subCatBtnClick = function () {
		eleMaps.each(function () {
			var t = $(this);
			var addedClass = t.attr('id');
			var distance = mapsList[addedClass].settings.ajaxMarkerListDistance;
			var maxResults = mapsList[addedClass].settings.ajaxMarkerListMaxResults;
			clearMap(addedClass);
			
			getMarkers(addedClass,distance,maxResults, t);
		});
	};
	
	win.on('load',function () {
		winWidth = win.width();
		eleMaps = $('.js-maps');
		loadings = $('.gmap-loading-item');
		subCatBtn = $('.recherche-filtre-sub-list-item');
		noResultMap = $('.recherche-content-carte .gmap-no-results');
		noResultList = $('.recherche-content-liste-inner .gmap-no-results');
		indexInputLocation = $('.recherche-pannel-index-mot-label-input.location');
		rechercheHeaderInputLocation = $('.recherche-header-filters-items.location');
		recherchePopupInput = $('.recherche-popup-input.ville');
		loadingPannels = $('.gmap-loading-pannel');
		
		defaults.zoom = $('#recherche-map').data('zoom');
		
		createMaps();
		
		//subCatBtn.click(subCatBtnClick);
	});
	
	var styles = [
		{
				"featureType": "landscape",
				"elementType": "all",
				"stylers": [
						{
								"hue": "#f2ff00"
						}
				]
		},
		{
				"featureType": "poi.park",
				"elementType": "all",
				"stylers": [
						{
								"visibility": "off"
						}
				]
		},
		{
				"featureType": "road",
				"elementType": "all",
				"stylers": [
						{
								"hue": "#ff0000"
						},
						{
								"weight": "1"
						}
				]
		},
		{
				"featureType": "road.arterial",
				"elementType": "all",
				"stylers": [
						{
								"hue": "#ffff00"
						}
				]
		},
		{
				"featureType": "road.local",
				"elementType": "all",
				"stylers": [
						{
								"visibility": "on"
						},
						{
								"weight": "1"
						},
						{
								"color": "#dbd9ce"
						}
				]
		},
		{
				"featureType": "road.local",
				"elementType": "labels.text.fill",
				"stylers": [
						{
								"visibility": "on"
						},
						{
								"color": "#6f6f5f"
						}
				]
		},
		{
				"featureType": "water",
				"elementType": "all",
				"stylers": [
						{
								"hue": "#007fff"
						}
				]
		}
];
	
})(jQuery);

/*!
 * jQuery ClassyLoader
 * www.class.pm
 *
 * Written by Marius Stanciu - Sergiu <marius@class.pm>
 * Licensed under the MIT license www.class.pm/LICENSE-MIT
 * Version 1.2.0
 *
 */

(function($) {
		$.fn.ClassyLoader = function(settings) {
				function radius(e) {
						return Math.PI / 180 * e;
				}
				var defaultSettings = {
						width: 200,
						height: 200,
						animate: true,
						displayOnLoad: true,
						percentage: 100,
						speed: 1,
						roundedLine: false,
						showRemaining: true,
						fontFamily: 'Helvetica',
						fontSize: '50px',
						showText: true,
						diameter: 80,
						fontColor: 'rgba(25, 25, 25, 0.6)',
						lineColor: 'rgba(55, 55, 55, 1)',
						remainingLineColor: 'rgba(55, 55, 55, 0.4)',
						lineWidth: 5,
						start: 'left'
				};
				settings = $.extend({
				}, defaultSettings, settings);
				var r = $(this);
				this.draw = function(percent) {
						if (typeof percent !== 'undefined') {
								settings.percentage = percent;
						}
						var ctx = r[0].getContext("2d");
						var hw = r.width() / 2;
						var hh = r.height() / 2;
						var u = 100;
						var a = 0;
						var startPos = 0;
						var f = function(e) {
								var t = radius(360) / u;
								return t * e;
						};
						ctx.scale(1, 1);
						ctx.lineWidth = settings.lineWidth;
						ctx.strokeStyle = settings.lineColour;
						var l = function(s, u) {
								s = s || f(a);
								u = u || f(a + 1);
								ctx.clearRect(0, 0, r.width(), r.height());
								if (settings.showRemaining === true) {
										ctx.beginPath();
										ctx.strokeStyle = settings.remainingLineColor;
										ctx.arc(hw, hh, settings.diameter, 0, 360);
										ctx.stroke();
										ctx.closePath();
								}
								ctx.strokeStyle = settings.lineColor;
								ctx.beginPath();
								if (settings.roundedLine === true) {
										ctx.lineCap = 'round';
								}
								else {
										ctx.lineCap = 'butt';
								}
								switch (settings.start) {
										case 'top':
												startPos = 1.5 * Math.PI;
												break;
										case 'bottom':
												startPos = 0.5 * Math.PI;
												break;
										case 'right':
												startPos = 1 * Math.PI;
												break;
										default:
												startPos = 0;
												break;
								}
								ctx.arc(hw, hh, settings.diameter, startPos, u + startPos);
								ctx.stroke();
								ctx.closePath();
								if (settings.showText === true) {
										ctx.fillStyle = settings.fontColor;
										ctx.font = settings.fontSize + " " + settings.fontFamily;
										ctx.textAlign = "center";
										ctx.textBaseline = "middle";
										ctx.fillText(a + 1 + "%", hw, hh);
								}
						};
						setTimeout(function c() {
								l(f(a), f(a + 1));
								a += 1;
								if (a < settings.percentage) {
										setTimeout(c, settings.speed);
								}
						}, settings.speed);
				};
				this.setPercent = function(percentage) {
						settings.percentage = percentage;
						return this;
				};
				this.getPercent = function() {
						return settings.percentage;
				};
				this.show = function() {
						var ctx = r[0].getContext("2d");
						var hw = r.width() / 2;
						var hh = r.height() / 2;
						ctx.scale(1, 1);
						ctx.lineWidth = settings.lineWidth;
						ctx.strokeStyle = settings.lineColour;
						ctx.clearRect(0, 0, r.width(), r.height());
						ctx.strokeStyle = settings.lineColor;
						ctx.beginPath();
						ctx.arc(hw, hh, settings.diameter, 0, radius(settings.percentage / 100 * 360));
						ctx.stroke();
						ctx.closePath();
						if (settings.showText === true) {
								ctx.fillStyle = settings.fontColor;
								ctx.font = settings.fontSize + ' ' + settings.font;
								ctx.textAlign = 'center';
								ctx.textBaseline = 'middle';
								ctx.fillText(settings.percentage + '%', hw, hh);
						}
						if (settings.showRemaining === true) {
								ctx.beginPath();
								ctx.strokeStyle = settings.remainingLineColor;
								ctx.arc(hw, hh, settings.diameter, 0, 360);
								ctx.stroke();
								ctx.closePath();
						}
				};
				this.__constructor = function() {
						$(this).attr('width', settings.width);
						$(this).attr('height', settings.height);
						if (settings.displayOnLoad === true) {
								if (settings.animate === true) {
										this.draw();
								} else {
										this.show();
								}
						}
						return this;
				};
				return this.__constructor();
		};
})(jQuery, window);